import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Flex } from 'foundations-components/components/Flex';
import { useSelector } from 'react-redux';
import { AllProductLines as AllProductLinesConstant } from 'self-service-api/constants/ProductLines';
import { ProductLevelAndProductLineToSuitePFTranslationKeyMap } from '../../../constants/PriorityFeaturesTranslationKeys';
import { useAppSelector } from '../../../reducers';
import { currentSkuIdForProductSelector, productSelector, productVersionSelector } from '../../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteFeaturesSubtext = ({
  productLevel,
  productLine
}) => {
  const product = useSelector(state => AllProductLinesConstant.includes(productLine) ? productSelector(state, {
    productLine,
    productLevel
  }) : null);
  const skuId = useAppSelector(state => product ? currentSkuIdForProductSelector(state, {
    productId: product.id
  }) : null);
  const quantityPackDetails = useAppSelector(state => {
    var _productVersionSelect;
    return skuId ? (_productVersionSelect = productVersionSelector(state, {
      skuId
    })) === null || _productVersionSelect === void 0 ? void 0 : _productVersionSelect.quantityPackDetails : [];
  });
  const quantityPack = quantityPackDetails === null || quantityPackDetails === void 0 ? void 0 : quantityPackDetails[0];
  if (!quantityPack) return null;
  const includedWithProductVersion = quantityPack === null || quantityPack === void 0 ? void 0 : quantityPack.includedWithProductVersion;
  const messageTranslation = ProductLevelAndProductLineToSuitePFTranslationKeyMap[productLevel][productLine]['subtext'];
  if (!messageTranslation) return null;
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: messageTranslation,
      elements: {
        IncludedAdditionalUnits: () => /*#__PURE__*/_jsx(FormattedNumber, {
          value: includedWithProductVersion !== null && includedWithProductVersion !== void 0 ? includedWithProductVersion : 0
        })
      }
    })
  });
};